// 公用部分
export default {
    totals: '总计',
    phoneNumber: '手机号',
    add: '添加',
    new: '新增',
    edit: '编辑',
    del: '删除',
    delete: '删除',
    BD: '批量删除',
    cancel: '取消',
    ok: '确定',
    save: '确定',
    numbering: '编号',
    remarks: '备注',
    details: '详情',
    description: '描述',
    start: '开始',
    complete: '完成',
    return: '返回',
    preservation: '保存',
    upload: '上传',
    download: '下载',
    bulkDownload: '批量下载',
    getSuccess: '获取成功',
    setSuccess: '设置成功',
    uploadSuccess: '上传成功',
    editSuccess: '编辑成功',
    addSuccess: '添加成功',
    RC: '读取完成',
    tip: '提示',
    warning: '警告',
    send: '已发送',
    saved: '已保存',
    deleteSuccessful: '已删除',
    deleteSuccess: '删除成功',
    on: '开',
    off: '关',
    success: '成功',
    failure: '失败',
    odifiedSuccess: '修改成功',
    selectUAV: '请选择无人机',
    tip_pleaseEnterLng: '请输入经度',
    tip_pleaseEnterLat: '请输入纬度',
    tip_pleaseEnterAlt: '请输入海拔高度',
    tip_lngFormatErr: '经度格式错误，请重新输入',
    tip_latFormatErr: '纬度格式错误，请重新输入',
    tip_altFormatErr: '海拔高度格式错误，请重新输入',
    tip_altMaxErr: '海拔高度超出系统最大限高9999',
    lngFormat: '经度范围为-180~180，请重新输入。',
    latFormat: '纬度范围为-90~90，请重新输入。',
    confirmRevision: '是否确认修改?',
    reset: '重置',
    search: '搜索',
    query: '查询',
    filter: '筛选',
    operation: '操作',
    use: '使用',
    returnstation: '返回地面站',
    ND: '暂无数据',
    time: '时间',
    startTime: '开始时间',
    to: '至',
    loading: '加载中',
    empty: '清空',
    selectAll: '全选',
    export: '导出',
    select: '选择',
    lng: '经度',
    lat: '纬度',
    folder: '文件夹',
    file: '文件',
    height: '高度',
    altitude: '海拔',
    relativeHeight: '相对高度',
    elevation: '海拔高度',
    speed: '速度',
    groundSpeed: '地速',
    airspeed: '空速',
    radius: '半径',
    setUp: '设置',
    digitalMap: '电子地图',
    satelliteMap: '卫星地图',
    level: '{name}级',
    online: '在线{0}',
    offline: '离线{0}',
    total: '总{0}',
    uav: '无人机',
    rtk: 'RTK',
    baseStation: '基站',
    weatherStation: '气象站',
    noFlyZone: '禁飞区',
    restrictedFlyArea: '限飞区',
    all: '全部',
    taskNumber: '任务编号',
    creationTime: '创建时间',
    founder: '创建人',
    deadline: '截止时间',
    startingTime: '开始时间',
    completeTime: '完成时间',
    endTime: '结束时间',
    workLocation: '作业地点',
    taskType: '任务类型',
    state: '状态',
    mapView: '地图查看',
    copy: '复制',
    paste: '粘贴',
    saveAndExit: '保存退出',
    hide: '隐藏',
    show: '显示',
    notInstalled: '未安装',
    unknown: '未知',

    // 气象站相关
    windSpeed: '风速',
    windDirection: '风向',
    temperature: '温度',
    humidity: '湿度',
    airPressure: '气压',

    // 任务类型
    pointReconnaissance: '点侦察',
    regionalReconnaissance: '区域侦察',
    orthophoto: '正射影像',
    tiltPhotography: '倾斜摄影',
    logisticsTransportation: '物流运输',

    tip_del: '是否确定删除？',
    tip_revoke: '是否确定撤销？',
    tip_recover: '是否确定恢复？',
    rightClickDelete: '右击删除我',
    tip_deletePermanently: '此操作将永久删除该数据,是否继续?',
    tip_SDT: '选择日期时间',
}